import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AmplitudeService } from '../../shared/services/amplitude.service';

@Component({
  selector: 'cc-first-steps-numbers',
  templateUrl: './first-steps-numbers.component.html',
  styleUrls: ['./first-steps-numbers.component.scss']
})
export class FirstStepsNumbersComponent implements OnInit {
  constructor(private router: Router, private amplitudeService: AmplitudeService) {}

  ngOnInit() {
    this.logAmplitude('Init - redirect to get number flow');
    this.router.navigateByUrl('welcome');
  }

  private logAmplitude(message: string) {
    this.amplitudeService.logEvent(`Panel:FirstSteps:Numbers: ${message}`);
  }
}
